import Avatar from '@/components/Avatar'
import Block from '@/components/Block'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import type { ClassSummaryPageSection } from '@/shared/api-generated-types'
import { useMemo } from 'react'
import * as styles from './style'

export interface Props extends Partial<ClassSummaryPageSection> {
  className?: string
}

const ClassSummaryBlock = ({ content, className = '' }: Props): JSX.Element => {
  const GuideLink = useMemo(() => {
    if (!content?.navigateToGuideAction?.url) return null
    return (
      <Text size="xs" className="fc-canvas lh-md-lte-tablet mb-0">
        <a href={content?.navigateToGuideAction?.url} className={styles.guideLine}>
          <Avatar size="xs" src={content?.guideAvatarUrl} className={styles.guidePhoto} />
          {content?.guideName}
        </a>
      </Text>
    )
  }, [content?.navigateToGuideAction?.url])

  return (
    <Block
      data-testid="class-summary-block-cp"
      theme="white"
      className={`${className} px-0 py-lg py-lg-gte-sm py-xl-gte-xxl`}
    >
      <Layout>
        <Stack y>
          <Text size="md" responsiveSize={{ sm: 'lg', lg: 'xl' }} weight="lg" className="fc-canvas mb-xxxs">
            {content?.title}
          </Text>
          {GuideLink}
        </Stack>
      </Layout>
    </Block>
  )
}

export default ClassSummaryBlock
